import React from 'react'
import { ResponsiveBox } from '@usap/uicomponents'
import TopBarHeading from './TopBarHeading'
import TopBarInformation from './TopBarInformation'

export default function TopBarHeadingContainer() {
  return (
    <ResponsiveBox
      id="topBarHeadingWrapper"
      fxPad={{ large: { left: 'xsmall' } }}
    >
      <TopBarHeading />

      <TopBarInformation />
    </ResponsiveBox>

  )
}
